export const GoogleTagManagerId = 'GTM-TXWB6CC';
